import React, { useState, useEffect, useContext } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { swalMessages, permitsList } from 'src/constants';
import swal from 'sweetalert';
import {
  putDetails,
  postFiles,
  deleteFile,
  getUrl,
} from 'src/services/insightDetailsService';
import Details from 'src/pages/InsigthFactory/Details';
import { toBase64 } from '@auteco/utils/toBase64';
import { Context } from '../../context/Contex';

const initialForm = {
  titulo: '',
  resumen: '',
  detalle: '',
  resultados: '',
  indicadores: '',
  tipo: 'detalle',
  cluster_id: null
};
const DetailsContainer = () => {
  const { id } = useParams();
  const history = useHistory();
  const location = useLocation();
  const [files, setFiles] = useState([]);
  const [form, setForm] = useState(initialForm);

  const { permisos } = useContext(Context);
  const permitValue = permisos[permitsList.FABRICA_INSIGHTS];


  const onChangeInputs = async (value, field) => {
    if (field === 'files') {
      const fileList = value[0];
      const { name } = fileList;
      const base64 = await toBase64(fileList);
      const { success, data } = await postFiles({
        id_entrada: id,
        nombreAdjunto: name,
        adjunto: base64,
      });
      if (success) {
        setFiles(data);
      }
    }
    setForm({ ...form, [field]: value });
  };

  const handleBack = () => {
    history.push('/insight_factory');
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { success } = await putDetails({
      id,
      ...form,
    });
    if (success) {
      swal(swalMessages.SUCCESSFUL_MESSAGE);
      history.push(`/insight_factory/insight/${id}`);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const handleDeleteFile = (index) => {
    const idFile = files[index].id;
    swal(swalMessages.DELETE_CONFIRM).then(async (willDelete) => {
      if (willDelete) {
        const { success, data } = await deleteFile(idFile);
        if (success) {
          setFiles(data);
        } else {
          swal(swalMessages.GENERAL_ERROR);
        }
      }
    });
  };

  const fetchUrl = async (index) => {
    const idFile = files[index].id;
    const { success, object } = await getUrl(idFile);
    if (success) {
      swal(object?.urlFirmada, { icon: 'success' });
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const withoutPermit = (permit) => {
    if (permit < 3) {
      history.push('/insight_factory');
    } else {
      return null;
    }
  };

  useEffect(() => {
    const { state } = location;
    withoutPermit(permitValue);
    if (state) {
      setForm({ ...form, titulo: state.asunto, resumen: state.cuerpo });
    }
  }, []);

  return (
    <Details
      files={files}
      form={form}
      fetchUrl={fetchUrl}
      handleBack={handleBack}
      handleSubmit={handleSubmit}
      onChangeInputs={onChangeInputs}
      handleDeleteFile={handleDeleteFile}
    />
  );
};

export default DetailsContainer;
